import { render, staticRenderFns } from "./DGORow.vue?vue&type=template&id=c89ab600&"
import script from "./DGORow.js?vue&type=script&lang=js&"
export * from "./DGORow.js?vue&type=script&lang=js&"
import style0 from "./DGORow.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports